import { render, staticRenderFns } from "./PrivacyPage.vue?vue&type=template&id=097f9a9b&scoped=true&"
import script from "./PrivacyPage.vue?vue&type=script&lang=js&"
export * from "./PrivacyPage.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPage.vue?vue&type=style&index=0&id=097f9a9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097f9a9b",
  null
  
)

export default component.exports